function negotiateLabel (button,text) {
	if (text)
		button.innerHTML = text;	
}

module.exports = negotiateLabel;
